export const AUTH_ROUTES = {
  index: {
    path: '/*',
    to: '/',
  },
  login: {
    path: 'login',
    to: '/login',
  },
  forgotPassword: {
    path: 'forgot-password',
    to: '/forgot-password',
  },
  resetPassword: {
    path: 'reset-password',
    to: '/reset-password',
  },
}
